import React, { Component } from 'react'
import Web3 from 'web3'
import './css.css';



class PairSwapperInstaller1_0 extends Component {
constructor(props){
    super()


}

async installNow(){
    
    let addr=this.props.address
    let db=this.props.box
    await window.ethereum.enable().then(async function (accounts) {   
        const { REACT_APP_PAIRSWAPPER1_0FACTORYABI } = process.env;
        const { REACT_APP_PAIRSWAPPER1_0FACTORY } = process.env;
        const factory = new web3.eth.Contract(JSON.parse(REACT_APP_PAIRSWAPPER1_0FACTORYABI), REACT_APP_PAIRSWAPPER1_0FACTORY) 
        await factory.methods.install(db).send({gasLimit: 3000000, from: accounts[0]})
        //reload 
    })
    this.props.reset()
}

async enableNow(){
    
    let addr=this.props.address
    let db=this.props.box
    await window.ethereum.enable().then(async function (accounts) {   
        const { REACT_APP_HAPPYBOXABI } = process.env;
        const { REACT_APP_PAIRSWAPPER1_0FACTORY } = process.env;
        const happybox = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), db) 
        await happybox.methods.set(REACT_APP_PAIRSWAPPER1_0FACTORY,true,1).send({gas: 123456, from: accounts[0]})
        //reload 
    })
    this.props.enable("swapper1_0installer")
}


    render(props){
    console.log(props)
   
            return ( <div>
                        
                <div className={(this.props.enabled)? "Ticket_Modules_Installer" : "Ticket_Modules_Installer_disabled" }> 
                  
                
    <span className="Ticket_module_icon">💫 </span> pair swap 1.0 installer
                
                                <br></br> 
                                <div className="desc2">swaps token for token</div>
                                
                                {(this.props.enabled)?
                                <input className="Ticket_module_install_button" onClick={() => this.installNow()} type="button" value="☄️ install"></input>              
                                :
                                <input className="Ticket_module_install_button" onClick={() => this.enableNow()} type="button" value="⚡️ enable"></input>              
                                 }
                                </div>
                        </div>         
                );   
        
    }


}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}



        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default PairSwapperInstaller1_0